import React, { FC } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import CustomAccordion from "components/CustomAccordion";

const BlockchainSection: FC = () => {
  return (
    <>
      <Typography component="h2" variant="h2" my={4}>
        Blockchain
      </Typography>
      <CustomAccordion title="What does it mean to connect an NFT with a physical product?">
        <Box width="100%">
          <Typography>
            At Uniqly.io, each physical item can be paired with a unique NFT
            that acts as a digital certificate of authenticity and ownership.
            This connection is made using secure NFC tags embedded in the
            product, allowing users to verify authenticity and link the item to
            a blockchain-verified NFT.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="Which blockchains does Uniqly support?">
        <Box width="100%">
          <Typography>
            NFTs created on Uniqly are deployed on the Polygon blockchain.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="Can someone scan my product's tag and steal my NFT?">
        <Box width="100%">
          <Typography>
            No. Scanning an NFC tag only reveals publicly accessible information
            or a redirect. Your NFT is securely stored in your wallet and cannot
            be transferred or accessed without your private keys.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="Can the content linked to an NFT be updated after it is minted?">
        <Box width="100%">
          <Typography>
            Yes. It is possible to update or modify content connected to the NFT
            even after it has been created, depending on the project
            requirements.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="Do I need a crypto wallet to use Uniqly?">
        <Box width="100%">
          <Typography>
            No. You can sign up and use Uniqly with just your email. When you
            mint your first NFT, a wallet is automatically created and linked to
            your account — no need for any prior setup.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="Can I link my own wallet to Uniqly?">
        <Box width="100%">
          <Typography>
            Yes. You can connect an external wallet (such as MetaMask or
            WalletConnect) to your Uniqly account at any time to manage your
            assets independently.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="Can I transfer my NFT to another wallet?">
        <Box width="100%">
          <Typography>
            Yes. Once the NFT is minted, it can be transferred to any wallet
            that supports the Polygon network. This gives you full flexibility
            to trade, gift, or store your NFT elsewhere.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="How long does it take to receive the physical item after purchasing the NFT?">
        <Box width="100%">
          <Typography>
            Delivery time varies depending on product type and destination.
            Typically, physical items are shipped within 10 to 45 business days
            after purchase.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="I have a physical product. How do I redeem the NFT?">
        <Box width="100%">
          <Typography>
            To claim your NFT, simply tap your phone against the NFC tag on the
            product. When a notification pops up, click it, enter the required
            information, and press "Mint". Your NFT will then be assigned to
            your Uniqly account — if you don't already have one, it will be
            created automatically during this process.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="Can I sell an NFT if the physical item has already been redeemed?">
        <Box width="100%">
          <Typography>
            Yes! Any NFT that you redeemed to the physical version is still
            valid and can be resold on the secondary market. It can be traded on
            marketplaces such as OpenSea.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="Can I assign tokens to a product from Uniqly?">
        <Box width="100%">
          <Typography>
            Yes. Assigning tokens or digital utility to a physical item is one
            of the features we can enable for your merch through Uniqly.
          </Typography>
        </Box>
      </CustomAccordion>
    </>
  );
};

export default BlockchainSection;
